export default {
	name: "test",
	data() {
		return {
			timenow: new Date()
		};
	},
	methods: {
		newTime() {
			this.timenow = new Date();
			setTimeout(function () {
				this.newTime();
			}.bind(this), 1000);
		}
	},
	mounted: function () {
		this.newTime();
	}
};